import apiClient from "../clinet";

// Get all galleries media
const getGalleriesMedia = async () => {
  const response = await apiClient.get("/galleries-media");
  return response.data;
};

// Get galleries media by gallery ID
const getGalleriesMediaByGalleryId = async (galleryId: string | number) => {
  const response = await apiClient.get(`/galleries-media/gallery/${galleryId}`);
  return response.data;
};

// Create new gallery media
const createGalleryMedia = async (mediaData: any) => {
  const response = await apiClient.post("/galleries-media", mediaData);
  return response.data;
};

// Update gallery media
const updateGalleryMedia = async ({
  id,
  data,
}: {
  id: string | number;
  data: any;
}) => {
  const response = await apiClient.put(`/galleries-media/${id}`, data);
  return response.data;
};

// Delete gallery media
const deleteGalleryMedia = async (id: string | number) => {
  const response = await apiClient.delete(`/galleries-media/${id}`);
  return response.data;
};

export default {
  getGalleriesMedia,
  getGalleriesMediaByGalleryId,
  createGalleryMedia,
  updateGalleryMedia,
  deleteGalleryMedia,
};
